(() => {
  'use strict';
  if (window.cnCartFeedbackControllerReadyV4) return;
  window.cnCartFeedbackControllerReadyV4 = true;

  const nativeFetch = window.fetch ? window.fetch.bind(window) : null;

  if (!nativeFetch) return;

  let toastTimer = null;
  let toastIsHovered = false;
  let lastStockToastAt = 0;
  let pendingHideTimer = null;

  const ERROR_SELECTORS = `
    .product-form__error-message-wrapper,
    .product-form__error-message,
    .cart-item__error,
    .cart-item__error-text,
    [role="alert"]
  `;

  function isDesktopHover() {
    return window.matchMedia('(min-width: 750px) and (hover: hover)').matches;
  }

  function getShopifyRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function getCartUrl() {
    if (window.routes && window.routes.cart_url) {
      return window.routes.cart_url;
    }

    return getShopifyRoot().replace(/\/?$/, '/') + 'cart';
  }

  function getCartJsonUrl() {
    return getShopifyRoot().replace(/\/?$/, '/') + 'cart.js';
  }

  function getRequestPath(input) {
    try {
      const url =
        typeof input === 'string'
          ? input
          : input && input.url
            ? input.url
            : '';

      return new URL(url, window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  }

  function isCartAddPath(path) {
    return path.includes('/cart/add');
  }

  function isCartChangePath(path) {
    return path.includes('/cart/change') || path.includes('/cart/update');
  }

  function normalizeText(text) {
    return String(text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function isPartialStockMessage(text) {
    const value = normalizeText(text);

    if (!value) return false;

    return (
      value.includes('aufgrund der verfügbarkeit') ||
      value.includes('aufgrund der verfuegbarkeit') ||
      (
        value.includes('wurden nur') &&
        value.includes('warenkorb') &&
        (
          value.includes('hinzugefügt') ||
          value.includes('hinzugefuegt')
        )
      )
    );
  }

  function isMaxStockMessage(text) {
    const value = normalizeText(text);

    if (!value) return false;

    return (
      value.includes('maximale menge') ||
      value.includes('maximal verfügbare menge') ||
      value.includes('maximal verfuegbare menge') ||
      value.includes('befindet sich bereits') ||
      value.includes('bereits in deinem warenkorb') ||
      value.includes('bereits im warenkorb') ||
      value.includes('warenbestand') ||
      value.includes('bestand') ||
      value.includes('verfügbare menge') ||
      value.includes('verfuegbare menge') ||
      value.includes('nicht genügend') ||
      value.includes('nicht genuegend') ||
      value.includes('nicht mehr verfügbar') ||
      value.includes('nicht mehr verfuegbar') ||
      value.includes('ausverkauft') ||
      value.includes('maximum quantity') ||
      value.includes('already in your cart') ||
      value.includes('not enough items') ||
      value.includes('not enough inventory') ||
      (
        value.includes('du kannst nur') &&
        value.includes('warenkorb')
      ) ||
      (
        value.includes('kannst du nur') &&
        value.includes('warenkorb')
      ) ||
      (
        value.includes('es können nur') &&
        value.includes('warenkorb')
      ) ||
      (
        value.includes('es koennen nur') &&
        value.includes('warenkorb')
      ) ||
      value.includes('du kannst nicht mehr') ||
      value.includes('you can only add') ||
      value.includes('you can only have') ||
      value.includes('inventory') ||
      value.includes('stock')
    );
  }

  function isStockMessage(text) {
    return isPartialStockMessage(text) || isMaxStockMessage(text);
  }

  function beginCartMutation() {
    window.clearTimeout(pendingHideTimer);
    document.body.classList.add('cn-cart-atc-pending');
  }

  function endCartMutation(delay = 0) {
    window.clearTimeout(pendingHideTimer);

    pendingHideTimer = window.setTimeout(() => {
      /*
        Shopify schreibt seine Fehlermeldung teilweise erst nach der bereits
        ausgewerteten Fetch-Antwort in den DOM. Vor dem Freigeben deshalb noch
        einmal erkennen und dauerhaft mit cn-stock-error-hidden markieren.
      */
      scanAndReplaceStockMessages();
      document.body.classList.remove('cn-cart-atc-pending');
    }, delay);
  }

  function getAmountFromPartialMessage(text) {
    const match = String(text || '').match(/wurden nur\s+(\d+)/i);

    return match ? match[1] : null;
  }

  function getStockToastCopy(message) {
    if (isPartialStockMessage(message)) {
      const amount = getAmountFromPartialMessage(message);

      return {
        title: 'Nur verfügbare Menge hinzugefügt',
        text: amount
          ? 'Aufgrund des Warenbestands wurden nur ' + amount + ' Artikel in deinen Warenkorb gelegt.'
          : 'Aufgrund des Warenbestands wurde nur die aktuell verfügbare Menge in deinen Warenkorb gelegt.'
      };
    }

    return {
      title: 'Maximale Menge erreicht',
      text: 'Die maximal verfügbare Menge befindet sich bereits in deinem Warenkorb.'
    };
  }

  function createToast() {
    let toast = document.querySelector('.cn-cart-toast');

    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'cn-cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    toast.innerHTML = `
      <span class="cn-cart-toast__icon" aria-hidden="true"></span>

      <span class="cn-cart-toast__content">
        <strong class="cn-cart-toast__title"></strong>
        <span class="cn-cart-toast__text"></span>
      </span>

      <a class="cn-cart-toast__link" href="${getCartUrl()}">Ansehen</a>
    `;

    toast.addEventListener('mouseenter', () => {
      if (!isDesktopHover()) return;

      toastIsHovered = true;
      window.clearTimeout(toastTimer);
    });

    toast.addEventListener('mouseleave', () => {
      if (!isDesktopHover()) return;

      toastIsHovered = false;
      hideToast();
    });

    document.body.appendChild(toast);

    return toast;
  }

  function hideToast() {
    const toast = document.querySelector('.cn-cart-toast');

    if (!toast) return;

    toast.classList.remove('is-visible');
  }

  function showToast(type, title, text, onVisible) {
    const toast = createToast();
    const icon = toast.querySelector('.cn-cart-toast__icon');
    const titleElement = toast.querySelector('.cn-cart-toast__title');
    const textElement = toast.querySelector('.cn-cart-toast__text');
    const link = toast.querySelector('.cn-cart-toast__link');

    toast.className = 'cn-cart-toast cn-cart-toast--' + type;

    if (icon) icon.textContent = type === 'success' ? '✓' : '!';
    if (titleElement) titleElement.textContent = title;
    if (textElement) textElement.textContent = text;

    if (link) {
      if (type === 'success') {
        link.style.display = '';
        link.href = getCartUrl();
      } else {
        link.style.display = 'none';
      }
    }

    window.clearTimeout(toastTimer);

    window.requestAnimationFrame(() => {
      if (typeof onVisible === 'function') {
        onVisible();
      }

      toast.classList.add('is-visible');

      window.cnCartFeedbackVisibleAt = Date.now();
      window.dispatchEvent(new CustomEvent('cn:cart-feedback-visible'));
    });

    toastTimer = window.setTimeout(() => {
      if (isDesktopHover() && toastIsHovered) return;

      hideToast();
    }, type === 'stock' ? 3800 : 2600);
  }

  function showSuccessToast(operation) {
    const now = Date.now();

    /*
      Jede bestätigte Add-Anfrage darf den Erfolg genau einmal auslösen.
      Anders als eine reine Zeitsperre blockiert dies keine weiteren,
      bewusst schnell nacheinander ausgeführten Warenkorb-Aktionen.
    */
    if (!operation || operation.successHandled) return;

    /*
      Wenn kurz vorher eine Bestandswarnung erkannt wurde,
      darf kein blaues Erfolgspopup mehr darübergelegt werden.
    */
    if (now - lastStockToastAt < 2400) return;

    operation.successHandled = true;

    showToast(
      'success',
      'Zum Warenkorb hinzugefügt',
      'Die Karte wurde erfolgreich gespeichert.',
      () => updateConfirmedProductQuantity(operation)
    );

  }

  function showStockToast(message) {
    const now = Date.now();

    if (now - lastStockToastAt < 650) return;

    lastStockToastAt = now;

    const copy = getStockToastCopy(message);

    showToast('stock', copy.title, copy.text);
  }

  async function getCart() {
    try {
      const response = await nativeFetch(getCartJsonUrl(), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      });

      if (!response.ok) return null;

      return await response.json();
    } catch (error) {
      return null;
    }
  }


  function getOriginalErrorWrapper(element) {
    if (!element) return null;

    return (
      element.closest('.product-form__error-message-wrapper') ||
      element.closest('.cart-item__error') ||
      element.closest('[role="alert"]') ||
      element
    );
  }

  function hideOriginalStockError(element) {
    const wrapper = getOriginalErrorWrapper(element);

    if (!wrapper) return;

    wrapper.classList.add('cn-stock-error-hidden');
    wrapper.setAttribute('aria-hidden', 'true');

    wrapper
      .querySelectorAll('.product-form__error-message, .cart-item__error-text')
      .forEach((textElement) => {
        textElement.textContent = '';
      });

    if (
      wrapper.matches &&
      (
        wrapper.matches('.product-form__error-message') ||
        wrapper.matches('.cart-item__error-text')
      )
    ) {
      wrapper.textContent = '';
    }
  }

  function resetHiddenStockErrors() {
    document.querySelectorAll('.cn-stock-error-hidden').forEach((element) => {
      element.classList.remove('cn-stock-error-hidden');
      element.removeAttribute('aria-hidden');
      element.removeAttribute('hidden');
    });
  }

  function scanAndReplaceStockMessages() {
    let foundMessage = '';

    document.querySelectorAll(ERROR_SELECTORS).forEach((element) => {
      const message = element.textContent || '';

      if (!isStockMessage(message)) return;

      if (!foundMessage) {
        foundMessage = message;
      }

      hideOriginalStockError(element);
    });

    if (foundMessage) {
      showStockToast(foundMessage);
      return true;
    }

    return false;
  }

  function scheduleStockMessageScan() {
    [40, 100, 220, 420, 750, 1200, 1800].forEach((delay) => {
      window.setTimeout(scanAndReplaceStockMessages, delay);
    });
  }

  function getProductForms() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
  }

  function getVariantIdFromForm(form) {
    if (!form) return null;

    const variantInput =
      form.querySelector('input[name="id"]') ||
      form.querySelector('select[name="id"]');

    if (!variantInput) return null;

    const variantId = Number(variantInput.value);

    return Number.isFinite(variantId) ? variantId : null;
  }

  function getQuantityInputFromForm(form) {
    if (!form) return null;

    return (
      form.querySelector('input[name="quantity"]') ||
      form.querySelector('.quantity__input')
    );
  }

  function getQuantityLabelFromForm(form) {
    const quantityInput = getQuantityInputFromForm(form);

    if (!quantityInput) return null;

    if (quantityInput.id && typeof window.CSS?.escape === 'function') {
      const labelByFor = document.querySelector('label[for="' + CSS.escape(quantityInput.id) + '"]');

      if (labelByFor) return labelByFor;
    }

    const quantityArea =
      quantityInput.closest('.product-form__quantity') ||
      quantityInput.closest('.product-form__input') ||
      quantityInput.closest('.quantity') ||
      quantityInput.parentElement;

    if (!quantityArea) return null;

    return (
      quantityArea.querySelector('label') ||
      quantityArea.querySelector('.form__label')
    );
  }

  function getVariantQuantityInCart(cart, variantId) {
    if (!cart || !Array.isArray(cart.items) || !variantId) return 0;

    return cart.items.reduce((total, item) => {
      if (Number(item.variant_id) === Number(variantId)) {
        return total + Number(item.quantity || 0);
      }

      return total;
    }, 0);
  }

  function cleanBaseLabelText(label) {
    if (!label) return 'Anzahl';

    const current = label.dataset.cnBaseLabel || label.textContent || 'Anzahl';

    return current
      .replace(/\s*\(\s*\d+\s+im\s+warenkorb\s*\)\s*/i, '')
      .replace(/\s*\(\s*\d+\s+im\s+Warenkorb\s*\)\s*/g, '')
      .trim() || 'Anzahl';
  }

  function replaceQuantityNumberOnly(label, quantityInCart) {
    if (!label) return;

    const cartRule = label.querySelector('.quantity__rules-cart');

    if (cartRule) {
      const walker = document.createTreeWalker(cartRule, NodeFilter.SHOW_TEXT);
      let textNode;

      while ((textNode = walker.nextNode())) {
        if (!/\d+/.test(textNode.nodeValue)) continue;

        textNode.nodeValue = textNode.nodeValue.replace(/\d+/, String(quantityInCart));
        cartRule.classList.toggle('hidden', quantityInCart <= 0);
        return;
      }
    }

    const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
    let textNode;

    while ((textNode = walker.nextNode())) {
      if (!/\d+\s+im\s+Warenkorb/i.test(textNode.nodeValue)) continue;

      textNode.nodeValue = textNode.nodeValue.replace(
        /\d+(?=\s+im\s+Warenkorb)/i,
        String(quantityInCart)
      );
      return;
    }
  }

  function updateConfirmedProductQuantity(operation) {
    if (!operation || !operation.variantId) return;

    getProductForms().forEach((form) => {
      if (getVariantIdFromForm(form) !== operation.variantId) return;

      const input = getQuantityInputFromForm(form);
      const label = getQuantityLabelFromForm(form);
      if (!input || !label) return;

      const currentQuantity = Number(input.dataset.cartQuantity || 0);
      const addedQuantity = Math.max(1, Number(operation.addedQuantity || 1));
      const nextQuantity = currentQuantity + addedQuantity;

      input.dataset.cartQuantity = String(nextQuantity);
      replaceQuantityNumberOnly(label, nextQuantity);
    });
  }

  function updateProductCartQtyLabels(cart) {
    /*
      Alte separate Hinweis-Elemente entfernen, falls sie vom alten Code
      noch im DOM erzeugt wurden.
    */
    document.querySelectorAll('.cn-product-cart-qty-note').forEach((note) => {
      note.remove();
    });

    getProductForms().forEach((form) => {
      const variantId = getVariantIdFromForm(form);
      const label = getQuantityLabelFromForm(form);

      if (!label) return;

      const quantityInCart = getVariantQuantityInCart(cart, variantId);

      const input = getQuantityInputFromForm(form);
      if (input) {
        input.dataset.cartQuantity = String(quantityInCart);
      }

      replaceQuantityNumberOnly(label, quantityInCart);
    });
  }

  async function refreshProductCartQtyLabels() {
    const cart = await getCart();

    if (!cart) return;

    updateProductCartQtyLabels(cart);
  }

  function scheduleProductCartQtyRefresh() {
    [0, 300].forEach((delay) => {
      window.setTimeout(refreshProductCartQtyLabels, delay);
    });
  }

  async function extractResponseText(response) {
    try {
      const contentType = response.headers.get('content-type') || '';

      if (contentType.includes('application/json')) {
        const json = await response.json();
        return JSON.stringify(json);
      }

      return await response.text();
    } catch (error) {
      return '';
    }
  }

  async function handleCartMutationResponse(responseClone, meta) {
    const responseText = await extractResponseText(responseClone);

    const responseHasStockMessage =
      isStockMessage(responseText) ||
      responseClone.status === 422;

    if (responseHasStockMessage) {
      showStockToast(responseText);
      scheduleProductCartQtyRefresh();
      scheduleStockMessageScan();
      endCartMutation(900);
      return;
    }

    if (!meta.isAdd || !responseClone.ok) {
      endCartMutation(120);
      return;
    }

    /*
      Eine erfolgreiche /cart/add-Antwort bestätigt das Hinzufügen bereits.
      Dadurch sind weder ein künstlicher 1050-ms-Timer noch ein zweiter
      serieller Abruf von /cart.js erforderlich.
    */
    showSuccessToast(meta);
    window.setTimeout(refreshProductCartQtyLabels, 450);
    scheduleStockMessageScan();
    endCartMutation(120);
  }

  window.fetch = async function(input, init) {
    const path = getRequestPath(input);
    const isAdd = isCartAddPath(path);
    const isChange = isCartChangePath(path);
    const shouldWatch = isAdd || isChange;

    const response = await nativeFetch(input, init);

    if (shouldWatch) {
      try {
        const requestBody = init && init.body;
        const variantId =
          requestBody && typeof requestBody.get === 'function'
            ? Number(requestBody.get('id'))
            : null;
        const addedQuantity =
          requestBody && typeof requestBody.get === 'function'
            ? Number(requestBody.get('quantity') || 1)
            : 1;

        handleCartMutationResponse(response.clone(), {
          isAdd,
          isChange,
          variantId: Number.isFinite(variantId) ? variantId : null,
          addedQuantity: Number.isFinite(addedQuantity) ? addedQuantity : 1
        });
      } catch (error) {
        scheduleProductCartQtyRefresh();
        scheduleStockMessageScan();
      }
    }

    return response;
  };

  function isAddToCartForm(form) {
    if (!form) return false;

    const action = form.getAttribute('action') || form.action || '';

    return action.includes('/cart/add');
  }

  document.addEventListener(
    'submit',
    function(event) {
      const form = event.target;

      if (!isAddToCartForm(form)) return;

      beginCartMutation();
      resetHiddenStockErrors();
      scheduleStockMessageScan();
    },
    true
  );

  document.addEventListener(
    'click',
    function(event) {
      const addButton = event.target.closest(
        'button[name="add"], button[type="submit"][name="add"], .product-form__submit'
      );

      if (addButton) {
        const form = addButton.closest('form');

        if (isAddToCartForm(form)) {
          beginCartMutation();
          resetHiddenStockErrors();
          scheduleStockMessageScan();
        }
      }

      const cartPlusButton = event.target.closest(
        '.cart-items .quantity__button[name="plus"]'
      );

      if (cartPlusButton) {
        beginCartMutation();
        resetHiddenStockErrors();
        scheduleProductCartQtyRefresh();
        scheduleStockMessageScan();
      }
    },
    true
  );

  document.addEventListener('change', function(event) {
    if (
      event.target.matches('input[name="id"], select[name="id"]') ||
      event.target.closest('variant-selects') ||
      event.target.closest('variant-radios')
    ) {
      scheduleProductCartQtyRefresh();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    scheduleProductCartQtyRefresh();
    scheduleStockMessageScan();
  });

  document.addEventListener('cart:updated', () => {
    scheduleProductCartQtyRefresh();
    scheduleStockMessageScan();
  });

  document.addEventListener('cart:refresh', () => {
    scheduleProductCartQtyRefresh();
    scheduleStockMessageScan();
  });

  document.addEventListener('shopify:section:load', () => {
    scheduleProductCartQtyRefresh();
    scheduleStockMessageScan();
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      scheduleProductCartQtyRefresh();
      scheduleStockMessageScan();
    }
  });

  /*
    Toast bereits unsichtbar vorbereiten, damit beim ersten Warenkorb-Ereignis
    kein DOM-Aufbau mehr nötig ist. Das Element belegt durch position: fixed
    keinen Layoutplatz und verursacht keinen Layout Shift.
  */
  if (document.body) {
    createToast();
  } else {
    document.addEventListener('DOMContentLoaded', createToast, { once: true });
  }

  scheduleProductCartQtyRefresh();
  scheduleStockMessageScan();
})();
